export const COMP_NAME = "鲸世信诚";
//  IS_TEST 为true 是 测试环境打包    false为正式环境打包
export const IS_TEST = false;
export const ROLE = "admin";
export let IMG_BASE_URL = "https://oss.jingshixc.com";
// 线上 API（打包/正式环境用完整域名）
export let BASE_URL = "https://api.jingshixc.com";
export let H5_PAGE_URL_PROD = "https://m.jingshixc.com";
if (IS_TEST) {
  BASE_URL = "https://shoptest.jinnex.tech";
  H5_PAGE_URL_PROD = "https://shoptest.jinnex.tech";
} else if (process.env.NODE_ENV === "development") {
  // 本地开发：走 setupProxy.js 转发到线上，不连本机 10020
  BASE_URL = "";
}
export const API_URL = `${BASE_URL}/${ROLE}`;
export const API_URL_PROD = `${BASE_URL}/${ROLE}`;

// 商城订单状态
export const STORE_ORDER_STATUS = Object.freeze({
  PENDING: 0,
  PAYED: 1,
  SENDED: 2,
  FINISHED: 3,
  CANCELED: 4,
  REFUNDING: 5,
  REFUNDED: 6,
  DELETED: 7,
  SENDING: 8,
  TIMEOUT: 9,
  BANKPAYED: 10,
});

export const STORE_ORDER_STATUS_MAP = Object.freeze({
  [STORE_ORDER_STATUS.PENDING]: "待支付",
  [STORE_ORDER_STATUS.PAYED]: "待发货",
  [STORE_ORDER_STATUS.SENDED]: "已发货",
  [STORE_ORDER_STATUS.FINISHED]: "已完成",
  [STORE_ORDER_STATUS.CANCELED]: "已取消",
  [STORE_ORDER_STATUS.REFUNDING]: "退款中",
  [STORE_ORDER_STATUS.REFUNDED]: "已退款",
  [STORE_ORDER_STATUS.DELETED]: "已删除",
  [STORE_ORDER_STATUS.SENDING]: "发货中",
  [STORE_ORDER_STATUS.TIMEOUT]: "已超时",
  [STORE_ORDER_STATUS.BANKPAYED]: "线下支付",
});

// 0整数，1小数，2布尔值，3字符串
export const constantTypes = Object.freeze({
  INTEGER: 0,
  FLOAT: 1,
  BOOLEAN: 2,
  STRING: 3,
});

export const BALANCE_RECORD_TYPES = Object.freeze({
  SYSTEM_PLUS: 0,
  SYSTEM_MINUS: 1,
  COMMISSION: 2,
  TRANSFER: 3,
  PAYMENT: 4,
  UNFREEZE: 5,
  SYSTEM_UNFREEZE: 6,
  WITHDRAW: 7,
  REFUND: 8,
  TECH_SHARE: 9,
  SALARY: 10,
  MARKET_SHARE: 11,
  SXY_SHARE: 12,
  COMMISSION_TEAM: 19,
  AGENT_SHARE: 20,
});

export const BALANCE_RECORD_TYPE_MAP = Object.freeze({
  [BALANCE_RECORD_TYPES.SYSTEM_PLUS]: "系统增加余额",
  [BALANCE_RECORD_TYPES.SYSTEM_MINUS]: "系统减少余额",
  [BALANCE_RECORD_TYPES.COMMISSION]: "佣金",
  [BALANCE_RECORD_TYPES.TRANSFER]: "内转",
  [BALANCE_RECORD_TYPES.PAYMENT]: "余额支付",
  [BALANCE_RECORD_TYPES.UNFREEZE]: "解冻",
  [BALANCE_RECORD_TYPES.SYSTEM_UNFREEZE]: "系统释放",
  [BALANCE_RECORD_TYPES.WITHDRAW]: "提现",
  [BALANCE_RECORD_TYPES.REFUND]: "退款",
  [BALANCE_RECORD_TYPES.TECH_SHARE]: "绩效收入",
  // [BALANCE_RECORD_TYPES.TECH_SHARE]: "系统增加余额",
  // [BALANCE_RECORD_TYPES.SALARY]: "薪酬发放",
  // [BALANCE_RECORD_TYPES.MARKET_SHARE]: "市场部运营补贴",
  // [BALANCE_RECORD_TYPES.SXY_SHARE]: "商学院补贴",
  [BALANCE_RECORD_TYPES.COMMISSION_TEAM]: "管理奖",
  [BALANCE_RECORD_TYPES.AGENT_SHARE]: "分红",
});

// 积分
export const POINT_RECORD_TYPES = Object.freeze({
  SYSTEM_PLUS: 0,
  SYSTEM_MINUS: 1,
  DAILY_CHECKIN: 2,
  UNLOCK: 3,
  TRANSFER: 4,
  PAYMENT: 5,
  REWARD: 6,
  TOPUP: 7,
  BUY_BACK: 8,
  LOCK: 9,
  REFUND: 10,
});

export const POINT_RECORD_TYPE_MAP = Object.freeze({
  [POINT_RECORD_TYPES.SYSTEM_PLUS]: "系统增加积分",
  [POINT_RECORD_TYPES.SYSTEM_MINUS]: "系统减少积分",
  [POINT_RECORD_TYPES.DAILY_CHECKIN]: "每日签到",
  [POINT_RECORD_TYPES.UNLOCK]: "释放",
  [POINT_RECORD_TYPES.TRANSFER]: "内转",
  [POINT_RECORD_TYPES.PAYMENT]: "下单赠送",
  [POINT_RECORD_TYPES.REWARD]: "奖励",
  [POINT_RECORD_TYPES.TOPUP]: "充值",
  [POINT_RECORD_TYPES.BUY_BACK]: "回购",
  [POINT_RECORD_TYPES.LOCK]: "待释放",
  [POINT_RECORD_TYPES.REFUND]: "订单退回",
});

export const INPUT_TYPES = Object.freeze({
  TEXT: "TEXT",
  TEXTAREA: "TEXTAREA",
  SELECT: "SELECT",
  RADIO: "RADIO",
  CHECKBOX: "CHECKBOX",
  UPLOAD: "UPLOAD",
});

export const DATA_TYPES = Object.freeze({
  STRING: "STRING",
  NUMBER: "NUMBER",
  BOOLEAN: "SELECT",
});

export const PAGE_TYPES = Object.freeze(["首页"]);

// 流水类型
export const TRANSACTION_TYPES = Object.freeze({
  PAYMENT: 1,
});

export const TRANSACTION_TYPE_MAP = Object.freeze({
  [TRANSACTION_TYPES.PAYMENT]: "订单支付",
});

// 入住审核
export const MERCHANT_APPLY_STATUS = Object.freeze({
  PENDING: 0,
  PASS: 1,
  REJECT: 2,
});

export const MERCHANT_APPLY_STATUS_MAP = Object.freeze({
  [MERCHANT_APPLY_STATUS.PENDING]: "待审核",
  [MERCHANT_APPLY_STATUS.PASS]: "已通过",
  [MERCHANT_APPLY_STATUS.REJECT]: "已拒绝",
});

export const UNITS = Object.freeze([
  "斤",
  "千克",
  "克",
  "只",
  "包",
  "袋",
  "吨",
  "盒",
  "个",
  "箱",
  "瓶",
]);

export const USER_LEVELS = Object.freeze({
  NONE: 0,
  VIP: 1,
  VIP2: 2,
  VIP3: 3,
});

export const USER_LEVEL_MAP = Object.freeze({
  [USER_LEVELS.NONE]: "普通用户",
  [USER_LEVELS.VIP]: "初级会员",
  [USER_LEVELS.VIP2]: "中级会员",
  [USER_LEVELS.VIP3]: "高级会员",
});

export const QRCODE_TYPES = Object.freeze({
  V1: "PAYMENT",
  V2: "SPEAKER",
  V3: "LOCK_GUEST",
  V4: "JING_XI_POS",
});
export const QRCODE_TYPE_LABELS = Object.freeze({
  [QRCODE_TYPES.V1]: "商家码牌 - 支付",
  [QRCODE_TYPES.V2]: "商家码牌 - 语音支付",
  [QRCODE_TYPES.V3]: "商家码牌 - 锁客",
  [QRCODE_TYPES.V4]: "鲸禧收银机",
  // DB 存储值（小写）映射，列表显示用
  payment: "商家码牌 - 支付",
  speaker: "商家码牌 - 语音支付",
  guestLock: "商家码牌 - 锁客",
  jingXiPOS: "鲸禧收银机",
});
export const ROLE_LEVELS = Object.freeze({
  V0: 0,
  V1: 1,
  V2: 2,
  V3: 3,
  V4: 4,
  V5: 5,
  V6: 6,
});
export const ROLE_LEVEL_MAP = Object.freeze({
  // [ROLE_LEVELS.V1]: "小零售商",
  // [ROLE_LEVELS.V2]: "中零售商",
  // [ROLE_LEVELS.V3]: "大零售商",
  // [ROLE_LEVELS.V4]: "小批发商",
  // [ROLE_LEVELS.V5]: "中批发商",
  // [ROLE_LEVELS.V6]: "大批发商",
  // [ROLE_LEVELS.V1]: "V1",
  // [ROLE_LEVELS.V2]: "V2",
  // [ROLE_LEVELS.V3]: "V3",
  // [ROLE_LEVELS.V4]: "V4",
  // [ROLE_LEVELS.V5]: "V5",
  // [ROLE_LEVELS.V6]: "V6",
  [ROLE_LEVELS.V0]: "",
  [ROLE_LEVELS.V1]: "V1 - 新锐会员",
  [ROLE_LEVELS.V2]: "V2 - 白银会员",
  [ROLE_LEVELS.V3]: "V3 - 黄金会员",
  [ROLE_LEVELS.V4]: "V4 - 铂金会员",
  [ROLE_LEVELS.V5]: "V5 - 钻石会员",
  [ROLE_LEVELS.V6]: "V6 - 星耀会员",
});

export const MESSAGE_TYPES = Object.freeze({
  TEXT: 0,
  IMAGE: 1,
  AUDIO: 2,
  VIDEO: 3,
  FILE: 4,
  TRANSFER: 5,
  PACKET: 6,
  CARD: 7,
  LOCATION: 8,
});

export const WITHDRAW_TYPES = Object.freeze({
  ALIPAY: 1,
  BANK: 2,
});

export const WITHDRAW_TYPE_MAP = Object.freeze({
  [WITHDRAW_TYPES.ALIPAY]: "支付宝",
  [WITHDRAW_TYPES.BANK]: "银行卡",
});

// 支付订单状态
export const PAYMENT_STATUS = Object.freeze({
  PENDING: 0,
  PAYED: 1,
  CANCELED: 2,
  TIMEOUT: 3,
  REFUNDING: 4,
  REFUNDED: 5,
  DELETED: 6,
});

export const PAYMENT_STATUS_MAP = Object.freeze({
  [PAYMENT_STATUS.PENDING]: "待支付",
  [PAYMENT_STATUS.PAYED]: "已支付",
  [PAYMENT_STATUS.CANCELED]: "已取消",
  [PAYMENT_STATUS.TIMEOUT]: "超时未支付",
  [PAYMENT_STATUS.REFUNDING]: "退款中",
  [PAYMENT_STATUS.REFUNDED]: "已退款",
  [PAYMENT_STATUS.DELETED]: "已删除",
});

export const USER_TITLES = Object.freeze({
  JIANZHI: "JIANZHI",
  SHIXI: "SHIXI",
  QUANZHI: "QUANZHI",
  ZHUGUAN: "ZHUGUAN",
  JINGLI: "JINGLI",
  ZONGCAI: "ZONGCAI",
});

export const USER_TITLE_MAP = Object.freeze({
  [USER_TITLES.JIANZHI]: "兼职",
  [USER_TITLES.SHIXI]: "实习",
  [USER_TITLES.QUANZHI]: "全职",
  [USER_TITLES.ZHUGUAN]: "主管",
  [USER_TITLES.JINGLI]: "经理",
  [USER_TITLES.ZONGCAI]: "总裁",
});

// 支付方式
export const PAY_METHODS = Object.freeze({
  BALANCE: 0,
  WXPAY: 1,
  ALIPAY: 2,
  BACKCARD: 3,
  POINT: 4,
  WXPAY_SCAN: 5,
  ALIPAY_SCAN: 6,
  OFFLINE: 7,
  TXQ: 8,
  SXY: 9,
  DHQ: 10,
  //微信H5公众号支付
  WXH5PAY: 11,
  //快付 - 微信H5公众号支付
  KF_WXH5PAY: 12,
  //快付 - 支付宝网页支付
  KF_ALIPAY: 13,
  /**
   * 快付-智付快捷(杭州主体)
   */
  KF_ZF_HZ: 14,
  /**
   * 裕富 - 快捷支付(杭州主体)
   */
  YF_HZ: 15,
  /**
   * 汇聚 - 快捷支付(杭州主体)
   */
  HJ_HZ: 16,
  /**
   * 拉卡拉 - 聚合收银台
   */
  LKL_JHSYT: 20,
  /**
   * 卡券支付
   */
  COUPON: 99,
});

export const PAY_METHOD_MAP = Object.freeze({
  [PAY_METHODS.BALANCE]: "权益金支付",
  [PAY_METHODS.WXPAY]: "微信支付(汇付)",
  [PAY_METHODS.ALIPAY]: "支付宝(汇付)",
  [PAY_METHODS.BACKCARD]: "银行卡",
  [PAY_METHODS.POINT]: "积分支付",
  [PAY_METHODS.WXPAY_SCAN]: "微信付款码",
  [PAY_METHODS.ALIPAY_SCAN]: "支付宝付款码",
  [PAY_METHODS.OFFLINE]: "线下支付",
  [PAY_METHODS.TXQ]: "添星券支付",
  [PAY_METHODS.SXY]: "快捷支付",
  [PAY_METHODS.DHQ]: "兑换券",
  [PAY_METHODS.WXH5PAY]: "微信公众号(汇付)",
  [PAY_METHODS.KF_WXH5PAY]: "微信公众号(快付)",
  [PAY_METHODS.KF_ALIPAY]: "支付宝(快付)",
  [PAY_METHODS.KF_ZF_HZ]: "快捷支付(智付)",
  [PAY_METHODS.YF_HZ]: "快捷支付(裕富)",
  [PAY_METHODS.HJ_HZ]: "快捷支付(汇聚)",
  [PAY_METHODS.LKL_JHSYT]: "拉卡拉(聚合收银)",
  [PAY_METHODS.COUPON]: "卡券支付",
});

export const TOPUP_CATEGORIES = Object.freeze({
  MOBILE: "MOBILE",
  DIAN: "DIAN",
  SHUI: "SHUI",
});

export const TOPUP_CATEGORY_MAP = Object.freeze({
  [TOPUP_CATEGORIES.MOBILE]: "话费充值",
  [TOPUP_CATEGORIES.DIAN]: "电费充值",
  [TOPUP_CATEGORIES.SHUI]: "水费充值",
});

export const TOPUP_STATUS = Object.freeze({
  PENDING: 0,
  PAYED: 1,
  SENDED: 2,
  FINISHED: 3,
  REFUNDED: 4,
});

export const TOPUP_STATUS_MAP = Object.freeze({
  [TOPUP_STATUS.PENDING]: "待支付",
  [TOPUP_STATUS.PAYED]: "待发货",
  [TOPUP_STATUS.SENDED]: "待确认",
  [TOPUP_STATUS.FINISHED]: "已完成",
  [TOPUP_STATUS.REFUNDED]: "已退款",
});

// 铁军
// export const TIEJUN_LEVELS = Object.freeze({
//   JIANZHI: 1,
//   QUANZHI: 2,
//   ZHUGUAN: 3,
//   JIANGJUN: 4,
//   YUANSHUAI: 5,
// });

export const TIEJUN_LEVELS = Object.freeze({
  TIEJUN_JIANZHI: 1,
  TIEJUN_CHUJI: 2,
  TIEJUN_ZHONGJI: 3,
  TIEJUN_GAOJII: 4,
  JINLI: 5,
  JINLI_GAOJI: 6,
  ZONGJIAN: 7,
});

export const TIEJUN_LEVEL_MAP = Object.freeze({
  [TIEJUN_LEVELS.TIEJUN_JIANZHI]: "兼职铁军",
  [TIEJUN_LEVELS.TIEJUN_CHUJI]: "初级铁军",
  [TIEJUN_LEVELS.TIEJUN_ZHONGJI]: "中级铁军",
  [TIEJUN_LEVELS.TIEJUN_GAOJII]: "高级铁军",
  [TIEJUN_LEVELS.JINLI]: "市场经理",
  [TIEJUN_LEVELS.JINLI_GAOJI]: "高级市场经理",
  [TIEJUN_LEVELS.ZONGJIAN]: "市场总监",
});

export const USER_STATUS = Object.freeze({
  BLOCKED: 0, // 禁止登录
  NORMAL: 1,
  LOCKED: 2, // 资金冻结
});

export const USER_STATUS_MAP = Object.freeze({
  [USER_STATUS.BLOCKED]: "禁止登录",
  [USER_STATUS.NORMAL]: "正常",
  [USER_STATUS.LOCKED]: "资金冻结",
});

export const COUPON_RECORD_TYPE_MAP = Object.freeze({
  [1]: "手动领取",
  [2]: "系统发放",
  [3]: "后台发送",
});

export const COUPON_RECORD_STATUS_MAP = Object.freeze({
  [1]: "未使用",
  [2]: "已使用",
  [3]: "已过期",
});

export const SALARY_RECORD_TYPES = Object.freeze({
  SYSTEM_PLUS: 0,
  SYSTEM_MINUS: 1,
  REWARD: 2,
  SEND: 3,
  FUDAO: 4,
});

export const SALARY_RECORD_MAP = Object.freeze({
  [SALARY_RECORD_TYPES.SYSTEM_PLUS]: "系统增加",
  [SALARY_RECORD_TYPES.SYSTEM_MINUS]: "系统减少",
  [SALARY_RECORD_TYPES.REWARD]: "推广奖励",
  [SALARY_RECORD_TYPES.SEND]: "发放",
  [SALARY_RECORD_TYPES.FUDAO]: "辅导奖励",
});

export const DEPARTMENTS = Object.freeze({
  TECH: 1,
  MARKET: 2,
  SXY: 3,
});

export const DEPARTMENT_MAP = Object.freeze({
  [DEPARTMENTS.TECH]: "技术部",
  [DEPARTMENTS.MARKET]: "市场部",
  [DEPARTMENTS.SXY]: "商学院",
});

export const SECTION_MAP = Object.freeze({
  1: "热销区",
  2: "优选区",
  3: "精品区",
});

export const POINT_CATEGORY_MAP = Object.freeze({
  1: "绿色积分",
  2: "红色积分",
  3: "消费积分",
  4: "公益积分",
});

export const XFQ_RECORD_TYPES = Object.freeze({
  SYSTEM_PLUS: 0,
  SYSTEM_MINUS: 1,
  COMMISSION: 2,
  TRANSFER: 3,
  PAYMENT: 4,
  UNLOCK: 5,
  SYSTEM_UNLOCK: 6,
  WITHDRAW: 7,
  REFUND: 8,
  // TECH_SHARE: 9,
  // SALARY: 10,
  // TO_ZZQ: 11, // 兑换增值券
  // FROM_ZZQ: 12, // 增值券兑换
  // FROM_BALANCE: 13, // 增值券兑换
  FROM_TXH: 14, // 增值券兑换
  AGENT_SHARE: 15, // 联创
  QUDAO_SHARE: 16, // 渠道
});

export const XFQ_RECORD_TYPE_MAP = Object.freeze({
  [XFQ_RECORD_TYPES.SYSTEM_PLUS]: "系统增加余额",
  [XFQ_RECORD_TYPES.SYSTEM_MINUS]: "系统减少余额",
  [XFQ_RECORD_TYPES.COMMISSION]: "佣金",
  [XFQ_RECORD_TYPES.TRANSFER]: "内转",
  [XFQ_RECORD_TYPES.PAYMENT]: "付款",
  [XFQ_RECORD_TYPES.UNLOCK]: "释放",
  [XFQ_RECORD_TYPES.SYSTEM_UNLOCK]: "系统释放",
  [XFQ_RECORD_TYPES.WITHDRAW]: "提现",
  [XFQ_RECORD_TYPES.REFUND]: "退款",
  // [XFQ_RECORD_TYPES.TECH_SHARE]: "绩效收入",
  // [XFQ_RECORD_TYPES.COMMISSION_TEAM]: "管理奖",
  [XFQ_RECORD_TYPES.FROM_TXH]: "添星汇划转",
  [XFQ_RECORD_TYPES.AGENT_SHARE]: "联创",
  [XFQ_RECORD_TYPES.QUDAO_SHARE]: "渠道",
});

// 商品状态
export const PRODUCT_STATUS = Object.freeze({
  PENDING: 0,
  ONSALE: 1,
  OFFSALE: 2,
});

export const PRODUCT_STATUS_MAP = Object.freeze({
  [PRODUCT_STATUS.PENDING]: "待审核",
  [PRODUCT_STATUS.ONSALE]: "已上架",
  [PRODUCT_STATUS.OFFSALE]: "已下架",
});

export const DELIVERY_TYPE_MAP = Object.freeze({
  ZITI: "自提",
  EXPRESS: "快递",
});